import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const Post = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({ content: `` });

  useEffect(() => {
    getData();
  }, [id]);

  const getData = () => {
    axios
      .get(`/api/v1/posts/get-by-slug/` + id)
      .then((res) => {
        if (res.data == null) {
          navigate(`/not-found`);
        }
        document.title = res.data.title;
        setData(res.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="post-container">
      <div className="post-title">{data.title}</div>

      <div
        className="post-description"
        dangerouslySetInnerHTML={{
          __html: data.content.replace(/background-color: [^;]+;/g, ''),
        }}
      />
    </div>
  );
};

export default Post;
